import type { Primitive } from 'zod';

import { MultiSelectOption } from '../MultiSelect';

export function sortSelectedDescending<Data extends Primitive>(
  a: MultiSelectOption<Data>,
  b: MultiSelectOption<Data>,
  selection: Data[]
) {
  const aSelected = selection.includes(a.value);
  const bSelected = selection.includes(b.value);
  // selected entries should be placed before unselected ones
  if (aSelected && !bSelected) {
    return -1;
  }
  if (!aSelected && bSelected) {
    return 1;
  }
  // ensure the empty value always gets put in last place
  if (a.value === '') {
    return 1;
  }
  if (b.value === '') {
    return -1;
  }
  return (a.label ?? String(a.value)).localeCompare(b.label ?? String(b.value));
}
